<template>
  <div
    :style="{color: textColor}"
    class="p2a-thank-you-wrapper">
    <div class="p2a-thank-you">
      <span
        class="p2a-thank-you-message"
        v-html="campaignThankYouMessage"/>
      <img
        v-if="campaignThankYouImage"
        :src="campaignThankYouImage"
        alt="Thank You"
        class="p2a-thank-you-image p2a-thank-you-image-sm">
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Routes from "Constants/campaign/whodoyouknow/routeNames";

export default {
  name: "ThankYou",
  computed: {
    ...mapState("campaign", {
      campaignDesignColors: state => state.campaignDesignColors,
      campaignThankYouImage: state => state.thankYouImage,
      campaignThankYouMessage: state => state.thankYouMessage
    }),
    ...mapState("wdyk", {
      relationships: state => state.relationships
    }),
    textColor() {
      return this.campaignDesignColors.formTextColor;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.relationships.length === 0) {
        vm.$router.push({ name: Routes.LOOKUP_STAKEHOLDERS });
      }
    });
  }
};
</script>
